import { Box, TextProps } from '@primer/react';
import React, { useState } from 'react';

interface ITextWithEllipseProps extends TextProps {
    text: string,
    lineNumber?: number,
    allowToggleText?: boolean
}

const TextWithEllipse = (props: ITextWithEllipseProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { text, lineNumber } = props;
    
    const toggleText = () => {
        if (props.allowToggleText)
            setIsExpanded((prev) => !prev);
    };
    
    // Nếu không có lineNumber hoặc lineNumber = 0, cho phép tự động xuống dòng
    if (!lineNumber || lineNumber === 0) {
        return (
            <Box sx={{ whiteSpace: "pre-line", wordWrap: "break-word" }}>
                {text}
            </Box>
        );
    }
    
    return (
        <Box sx={{ whiteSpace: "pre-line" }}>
            {!isExpanded ? (
                <Box onClick={toggleText}
                    style={{
                        display: "-webkit-box",
                        WebkitLineClamp: lineNumber, // Sử dụng số dòng được truyền vào
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        cursor: props.allowToggleText ? "pointer" : "default",
                    }}
                    sx={{
                        ...props.sx,
                    }}
                >
                    {text}
                </Box>
            ) : (
                <Box onClick={toggleText} sx={{ wordWrap: "break-word" }}>
                    {text}
                </Box>
            )}
        </Box>
    );
};

export default TextWithEllipse;
